import * as S from './signup.styles.jsx';
import { Container } from '@mui/material';
import { useIsURLSearchParamMatch } from 'hooks/useURLSearchParams';
import { useVerificationMessage } from 'hooks/auth.js';
import SignupForm from './signup-form/signup-form.component.jsx';
import Thankyou from './thank-you/thank-you.component.jsx';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from 'hooks/usePageTitle.hooks.js';
import { Helmet } from 'react-helmet';

const SignupPage = () => {
  const isHideHeader = useIsURLSearchParamMatch('embed', 'true');
  const { state, setState, verificationMessage, verificationMethod, label } =
    useVerificationMessage();
  const { t } = useTranslation();
  const title = usePageTitle(t('head.title.signup'));

  const onSuccess = data => {
    const { verified, email, phoneNumber, password } = data;

    if (!verified) {
      setState(state => ({
        ...state,
        email,
        phoneNumber,
        password,
        verified: false,
        signupSuccess: true,
      }));
    } else {
      setState({ signupSuccess: true });
    }
  };

  return (
    <S.CustomBox ishideheader={isHideHeader ? 'true' : undefined}>
      <Helmet title={title} />
      <Container maxWidth="md">
        {!state.signupSuccess ? (
          <SignupForm onSuccess={onSuccess} />
        ) : (
          <Thankyou
            state={state}
            verificationMessage={verificationMessage}
            verificationMethod={verificationMethod}
            label={label}
          />
        )}
      </Container>
    </S.CustomBox>
  );
};

export default SignupPage;
